import * as React from "react";
import cx from "classnames";
import stylesV2 from "./Card.module.scss";
import stylesV3 from "./CardV2.module.scss";
import { useSchedulingABVariant } from "../../features/scheduling/utils/useSchedulingABVariant";


type CardTheme = "desktopOnly";

type CardProps = {
  children?: React.ReactNode;
  className?: string;
  theme?: CardTheme;
};

export const Card: React.FC<CardProps> = ({ children, className, theme }) => {
  const { isV3 } = useSchedulingABVariant();
  const styles = isV3 ? stylesV3 : stylesV2;
  return (
    <section
      className={cx(styles.card, className, {
        [styles.desktopOnly]: theme === "desktopOnly",
      })}
    >
      {children}
    </section>
  );
};
